<template>
  <div class="main_visual">
    <div class="visual_wrap" ref="mainSlider">
      <div
        class="visual_item"
        v-for="(slide, index) in mainSlides"
        :class="getSlideClass(index)"
      >
        <div class="visual_tit">
          <b>{{ slide.title1 }}</b>
          <h2 v-html="slide.title2"></h2>
          <p v-html="slide.desc"></p>
        </div>
        <div class="visual_bg">
          <img :src="require(`@/assets/images/main/${slide.img}`)" :alt="slide.title1"/>
          <img class="mob_img" :src="require(`@/assets/images/main/${slide.moImg}`)" :alt="slide.title1"/>
        </div>
      </div>
    </div>
    <div class="slide_controller">
      <div class="slide_numbers">
        <div
          class="slide_item"
          v-for="num in mainSlides.length"
        >
          <span class="slide_number">0{{ num }}</span>
          <div class="slide_progress">
            <span class="progress_fill"></span>
          </div>
        </div>
        <div class="slide_nav">
          <button class="slide_prev slide-arrow">
            <span class="sr_only">이전</span>
          </button>
          <button class="slide_next slide-arrow">
            <span class="sr_only">다음</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="box_area">
    <div class="box">
        <h5>White <span>Blossom</span></h5>
        <p>기쁜날 축하의 마음을 정성가득 전합니다.</p>
        <div class="img_wrap">
            <div>
                <div class="img_box">
                  <a href="#" @click.prevent="$router.push('/wedding')">
                    <img src="@/assets/images/main/box_img_01.png" alt="청첩장 만들기">
                  </a>
                </div>
                <span>청첩장 만들기</span>
            </div>
            <div>
                <div class="img_box">
                  <a href="#" @click.prevent="$router.push('/customer-service/notice-dtl/18')">
                    <img src="@/assets/images/main/box_img_02.png" alt="청첩장 제작가이드">
                  </a>
                </div>
                <span>청첩장 제작가이드</span>
            </div>
        </div>
    </div>
    <div class="box">
        <h5>Black <span>Blossom</span></h5>
        <p>추모와 애도, 위로의 뜻을 전합니다.</p>
        <div class="img_wrap">
            <div>
                <div class="img_box">
                  <a href="#" @click.prevent="$router.push('/funeral')">
                    <img src="@/assets/images/main/box_img_03.png" alt="기부 근조화환">
                  </a>
                </div>
                <span>부고장 만들기</span>
            </div>
            <div>
                <div class="img_box">
                  <a href="#" @click.prevent="$router.push('/customer-service/notice-dtl/19')">
                    <img src="@/assets/images/main/box_img_04.png" alt="부고장 제작가이드">
                  </a>
                </div>
                <span>부고장 제작가이드</span>
            </div>
        </div>
    </div>
</div>
<div class="digital_area">
    <div class="digital_txt">
        <p>Blossom Logos</p>
        <h5>디지털화환</h5>
        <span>
            구매하신 디지털 화환의 <b>구매금액의 50%</b>는 <br>
            선택하신 <b>기부단체에 자동으로 기부</b>가 진행됩니다.
        </span>
        <a href="">자세히 보기 <i class="ico_less"></i></a>
    </div>
    <div class="digital_bg">
        <img src="@/assets/images/main/digital_bg2.png" alt="디지털화환">
        <img class="mob_img" src="@/assets/images/main/digital_bg2_mo.png" alt="디지털화환">
    </div>
</div>
<div class="sponsorship_area">
    <div class="tit_wrap">
        <h5># 후원 활동 소식</h5>
        <a href="#" @click.prevent="$router.push('/sponsor')">전체보기 <i class="ico_less"></i></a>
    </div>
    <div class="sponsorship_wrap" ref="sponsorshipSlider">
        <div
          class="sponsorship_item"
          v-for="slide in mainPageSponsors"
        >
            <div class="img_box" 
            @click.prevent="$router.push('/sponsor/sponsor-dtl/' + slide.sponsorSeq)" 
            style="cursor: pointer;">
                <img
                  :src="$getImgUrl(slide.thumbnailPath)"
                  alt=""
                  @error="handleImgError"
                >
            </div>
            <div class="txt_box">
                <p class="enterprise_name">{{ $truncateText(slide.sponsorTitle, 20) }}</p>
                <div class="product_type">{{ $truncateText(slide.sponsorContent, 20) }}</div>
                <span class="amount_area">
                    <span>후원액</span>
                    <strong>{{ $addComma(slide.sponsorAmount)+"원"}}</strong>
                </span>
            </div>
        </div>
    </div>
    <div class="sponsorship_nav">
        <button class="sponsorship_prev">
            <span class="sr_only">이전</span>
        </button>
        <button class="sponsorship_next">
            <span class="sr_only">다음</span>
        </button>
    </div>
</div>
<div class="agency_area">
    <div class="agency_txt">
        <p><b>Blossom</b>Logos</p>
        <h5>후원 기관 안내</h5>
        <span>BlossomLogos의 후원 기관을 소개합니다.</span>
        <a href="#" @click.prevent="$router.push('/donation')">자세히 보기 <i class="ico_less"></i></a>
    </div>
    <div class="agency_bg">
        <img src="@/assets/images/main/agency_bg.png" alt="후원 기관 안내">
        <img class="mob_img" src="@/assets/images/main/agency_bg_mo.png" alt="후원 기관 안내">
    </div>
</div>
<div class="review_area">
    <div class="review_inner">
        <div class="tit_wrap">
            <h5>베스트 사용 후기</h5>
            <a href="" style="display:none;">전체보기 <i class="ico_less"></i></a>
        </div>
        <div class="review_wrap" ref="reviewSlider">
            <div
              class="review_item"
              v-for="slide in reviewSlides"
            >
                <div class="img_box">
                    <img :src="require(`@/assets/images/main/${slide.img}`)" alt="리뷰1">
                </div>
                <div class="txt_box">
                    <div class="score_wrap">
                        <div class="score" :data-score="slide.score"></div>
                    </div>
                    <h5>{{ slide.name }}</h5>
                    <p v-html="slide.desc"></p>
                </div>
            </div>

        </div>
        <div class="review_nav">
            <button class="review_prev">
                <span class="sr_only">이전</span>
            </button>
            <button class="review_next">
                <span class="sr_only">다음</span>
            </button>
        </div>
    </div>
</div>
<div class="story_area">
    <div class="story_card">
        <div class="txt_box">
          <a href="/sponsor">
            <span>Blossom Logos</span>
            <div class="tit">행복 스토리</div>
            <p>기부의 꽃이 만개하는 스토리를 소개합니다.</p>
            <div class="ico_plus">
                <img src="@/assets/images/common/ico_plus.png" alt="행복 스토리">
            </div>
          </a>
        </div>
    </div>

    <div class="payment_card">
      <div class="tit">
          <h5>고마우신 분들</h5>
      </div>
      <div class="list">
        <table class="basic main">
          <colgroup>
            <col style="width:20%">
            <col style="width:60%">
            <col style="width:20%">
          </colgroup>
          <thead>
            <tr>
              <th>이름</th>
              <th>후원 캠페인</th>
              <th>기부금</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in mainPaymentList" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.campaignName }}</td>
              <td>{{ $addComma(item.amount) }}원</td>
            </tr>
            
          </tbody>
        </table>

      </div>
    </div>
    <!--
    <div class="story_card">
        <div class="txt_box">
          <a href="/sponsor">
            <span>Blossom Logos</span>
            <div class="tit">디지털 화환 제작 스토리</div>
            <p>디지털 화환 제작 과정을 소개합니다.</p>
            <div class="ico_plus">
                <img src="@/assets/images/common/ico_plus.png" alt="디지털 화환 제작 스토리">
            </div>
          </a>
        </div>
    </div>
    -->
</div>
<div class="cs_area">
    <div class="cs_wrap">
        <div class="tit_wrap">
            <h5>고객센터</h5>
            <a href="/customer-service/inquiry-create">1:1 문의하기 <i class="ico_less"></i></a>
        </div>
        <div class="num_wrap">
            <div>
                <span>BlossomLogos 대표전화</span>
                <div>070-4233-0655</div>
                <p>통화량이 많을 때는 1:1 문의를 이용해주세요.</p>
            </div>
            <ul>
                <li>
                    <p>평 일</p>
                    <span>09:00 ~ 17:30</span>
                </li>
                <li>
                    <p>토요일/일요일</p>
                    <span>휴무</span>
                </li>
                <li>
                    <p>공휴일</p>
                    <span>휴무</span>
                </li>
            </ul>
        </div>
    </div>
    <div class="service_wrap">
        <div class="tit_wrap">
            <h5>부가서비스</h5>
        </div>
        <div class="box_wrap">
            <div class="box">
                <a href="/customer-service/faq-list">
                    <div class="img_wrap">
                        <img src="@/assets/images/main/service_ico_01.png" alt="증빙서류 신청">
                    </div>
                    <p>증빙서류 신청</p>
                </a>
            </div>
            <div class="box">
                <a @click="getPaymentInfo">
                    <div class="img_wrap">
                        <img src="@/assets/images/main/service_ico_02.png" alt="전자결제조회회">
                    </div>
                    <p>전자결제조회</p>
                </a>
            </div>
            <div class="box">
                <a href="/sponsor">
                    <div class="img_wrap">
                        <img src="@/assets/images/main/service_ico_03.png" alt="후원활동 메시지">
                    </div>
                    <p>후원활동 메시지</p>
                </a>
            </div>
        </div>
    </div>
</div>
<div class="notice_area">
    <div class="notice_inner">
        <div class="title"><a @click="toNoticeList">공지사항 <span></span></a></div>
        <ul class="notice_rolling">
            <li v-for="notice in mainPageNotices">
              <a @click="toNotice(notice.noticeSeq)">
                <p>{{ notice.title }}</p>
                <span>{{ notice.createDate }}</span>
              </a>
            </li>
        </ul>

    </div>
</div>

<MainSideBar/>

</template>

<script>
import $ from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel";

import MainSideBar from "./layout/navigation/MainSideBar.vue";
import { mapActions, mapState } from "vuex";

const noticeModule = 'noticeModule'
const sponsorModule = 'sponsorModule'
const paymentModule = 'paymentModule'

export default {
  components: {
    MainSideBar
  },
  data() {
    return {
      autoplaySpeed: 2000,
      mainSlides: [
        {
          title1: '진심(陳 베풀 진 心 마음 심)',
          title2: '행복의 기부',
          desc: '기쁨과 슬픔의 순간을 함께 나누며, <br />디지털 화환 기부를 통해 행복의 꽃을 만개하세요.',
          img: 'main_visual_01.png',
          moImg: 'main_visual_mo_01.png'
        },
        {
          title1: '진심(陳 베풀 진 心 마음 심)',
          title2: 'White <span>Blossom</span>',
          desc: '기쁨과 행복한 순간을 함께 나누며, <br />디지털 화환 기부를 통해 행복의 꽃을 만개하세요.',
          img: 'main_visual_02.png',
          moImg: 'main_visual_mo_02.png'
        },
        {
          title1: '진심(陳 베풀 진 心 마음 심)',
          title2: 'Black <span>Blossom</span>',
          desc: '그리움과 슬픔의 순간을 함께 나누며, <br />디지털 화환 기부를 통해 마음의 위안을 받으세요.',
          img: 'main_visual_03.png',
          moImg: 'main_visual_mo_03.png'
        },
      ],

      reviewSlides: [
        {
          img: 'blossom_review_01.jpg',
          name: '노을이 있는 멋진날',
          desc: '그 어느 화환보다 예쁘고 그곳에서 <br>가장 빛나는 멋진 화환이였습니다.',
          score: 4
        },
        {
          img: 'blossom_review_02.jpg',
          name: '사랑하는 사람과 첫걸음',
          desc: '결혼식이 이렇게 아릅답게 치러질 수 있었던 건 모두 여러분 덕분입니다.',
          score: 4
        },
        {
          img: 'blossom_review_03.jpg',
          name: '깊은 슬픔과 아쉬움',
          desc: '그분의 삶이 남긴 가르침과 사랑을 기억하며, 앞으로도 그분의 뜻을 이어가겠습니다.',
          score: 5
        },
        {
          img: 'blossom_review_04.jpg',
          name: '가장 소중한 사람들',
          desc: '가장 소중한 사람들과 함께한 결혼식, 앞으로의 삶도 함께 나누고 싶습니다.',
          score: 4
        },
        {
          img: 'blossom_review_05.jpg',
          name: '어려운 순간 함께해주신 분',
          desc: '많은 분들이 주문해 주셔서 감사드립니다. 따뜻한 위로와 응원에 힘이 되었습니다.',
          score: 5
        },
        {
          img: 'blossom_review_06.jpg',
          name: '오늘이 가장 특별한 날 ',
          desc: '저희의 새로운 시작을 축복해 주셔서 너무 행복했어요. 진심으로 사랍합니다.',
          score: 5
        },
      ],

      $mainSlider: {}
    };
  },
  async mounted() {
    await this.requestNoticeListForMainPage();
    await this.requestSponsorListForMainPage();
    await this.getMainPageList({ status: 'PAID'});

    this.initMainSlider();
    this.initSponsorshipSlider();
    this.initReviewSlider();
    this.initNoticeRolling();
  },
  methods: {
    ...mapActions(noticeModule, ['requestNoticeListForMainPage']),
    ...mapActions(sponsorModule, ['requestSponsorListForMainPage']),
    ...mapActions(paymentModule, ['getMainPageList']),

    initMainSlider() {
      const { autoplaySpeed } = this;
      const $mainSlider = $(this.$refs.mainSlider);

      // slick 초기화
      $mainSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed,
        prevArrow: $(".slide_prev"),
        nextArrow: $(".slide_next"),
        pauseOnFocus: false,
        pauseOnHover: false,
        rows: 0
      });

      // beforeChange 이벤트 핸들러
      $mainSlider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
        $(".slide_progress").removeClass("active");
        $(".progress_fill").css({ width: "0", transition: "none" });

        const $nextSlide = $(".slide_item").eq(nextSlide);
        const $nextProgress = $nextSlide.find(".slide_progress");

        $nextProgress.addClass("active");
        void $nextProgress[0]?.offsetWidth; // 강제 Reflow

        $nextProgress.find(".progress_fill").css({
          width: "100%",
          transition: `width ${autoplaySpeed}ms linear`,
        });
      });

      // 첫 슬라이드의 진행 표시 초기화
      const $firstProgress = $(".slide_item").first().find(".slide_progress");
      $firstProgress.addClass("active").find(".progress_fill").css({
        width: "100%",
        transition: `width ${autoplaySpeed}ms linear`,
      });

      this.$mainSlider = $mainSlider;
    },
    initSponsorshipSlider() {
      $(this.$refs.sponsorshipSlider).not(".slick-initialized").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: $(".sponsorship_prev"),
        nextArrow: $(".sponsorship_next"),
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [ // 반응형 웹 구현 옵션
          {
            breakpoint: 1024,
            settings: {
              slidesToShow:3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:2
            }
          }
        ]
      });
    },
    initReviewSlider() {
      $(this.$refs.reviewSlider).not(".slick-initialized").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: $(".review_prev"),
        nextArrow: $(".review_next"),
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [ // 반응형
          {
            breakpoint: 1024,
            settings: {
              slidesToShow:4
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:2
            }
          }
        ]
      });
    },
    initNoticeRolling() {
      const $noticeRolling = $(".notice_rolling");
      const $notices = $noticeRolling.find("li");
      const noticeHeight = $notices.outerHeight();

      $noticeRolling.append($notices.first().clone());

      let currentIndex = 0;

      const noticeRolling = () => {
          currentIndex++;
          $noticeRolling.animate(
              { top: -currentIndex * noticeHeight },
              600,
              function () {
                  if (currentIndex >= $notices.length) {
                      $noticeRolling.css("top", 0);
                      currentIndex = 0;
                  }
              }
          );
      };

      setInterval(noticeRolling, 3000);
    },

    toNotice (noticeSeq) {
      this.$router.push({
        name: 'NoticeDtlPage',
        params: { noticeSeq: noticeSeq.toString() }
      })
    },

    handleImgError(event) {
      const images = [
        require('@/assets/images/main/sponsorship_img_01.png'),
        require('@/assets/images/main/sponsorship_img_02.png'),
        require('@/assets/images/main/sponsorship_img_03.png'),
        require('@/assets/images/main/sponsorship_img_04.png'),
      ];
      const randomIndex = Math.floor(Math.random() * images.length);
      event.target.src = images[randomIndex];
    },

    getSlideClass(idx) {
      return 'item' + (idx+1)
    },

    toNoticeList() {
      this.$router.push({ name: 'NoticeListPage' })
    },

    getPaymentInfo() {
      this.$openModal('donationReceiptModal')
    },
    
  },

  computed: {
    ...mapState(noticeModule, ['mainPageNotices']),
    ...mapState(sponsorModule, ['mainPageSponsors']),
    ...mapState(paymentModule, ['mainPaymentList']),
  },

  beforeDestroy() {
      this.$mainSlider.slick("unslick")
      this.$mainSlider.off("beforeChange");
  },
};
</script>

<style>
</style>
